import { CreditCardStatus, PaymentMethodType, WorkflowPlace } from '@nemuru-eng/js-api-client';

import { CreditCardWorkflow, StatusDefinition } from '@/config/types';

export type Workflow = CreditCardWorkflow;
export type WorkflowStatus = CreditCardStatus;

export abstract class AbstractProgressWorkflow {
  public static readonly PAYMENT_METHOD_TYPES_WITH_WORKFLOW = [PaymentMethodType.CREDIT_CARD];

  constructor(protected readonly _status: WorkflowStatus, protected readonly _workflow: Workflow) {}

  public abstract isActive: boolean;
  public abstract isFinished: boolean;
  public abstract steps: WorkflowPlace[];
  public abstract statusDefinition: StatusDefinition;
  public abstract shouldClientPerformTheSteps: boolean;
  public abstract hasPassedScoring: boolean;

  public get status(): WorkflowStatus {
    return this._status;
  }

  public get workflow(): Workflow {
    return this._workflow;
  }

  public get isValid(): boolean {
    return !!this._workflow && !!this._workflow.place.name;
  }

  public get statusTextId(): string {
    return this.statusDefinition.DESCRIPTION_T_ID;
  }

  public get currentStepTextId(): string {
    return this._workflow.place.name;
  }

  public get progressPercentage(): number {
    return this._workflow.place.progress;
  }

  public get isCompleted(): boolean {
    return this._workflow.place.name === WorkflowPlace.COMPLETED;
  }

  public get numberOfCompletedSteps(): number {
    return this.steps.reduce((acc, step) => (this._workflow.logs.find((log) => log.from === step) ? acc + 1 : acc), 0);
  }
}
